<ng-container *transloco="let t;">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title" id="readOnlySchemaDialogLabel">{{t("schema.schemaawaiting.title")}}</h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p >{{ t("schema.schemaawaiting.schemaawaitingtext") }}</p>
                <p class="m-0">{{ t("schema.schemaawaiting.availableactionstext") }}</p>
            </div>
            <div class="modal-footer">
                <button class="btn wp-btn" type="button" data-bs-dismiss="modal">
                    {{ t("schema.schemaawaiting.close") }}
                </button>
            </div>
        </div>
    </div>
</ng-container>